import { useState, useEffect } from 'react';

import {
  Grid,
  Typography,
  TextField,
  Button
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { ViewerComponent } from '../commons/viewer/viewer.component';
import { getCategory, updateCategory } from '../../services/categories.service';
import { BackdropComponent } from '../commons/backdrop/backdrop.component';

export const CategoriesEditComponent = () => {

  const { id } = useParams();

  const history = useHistory();

  const [category, setCategory] = useState();

  const [loading, setLoading] = useState(true);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchCategory = async (id) => {
      const item = await getCategory(id);
      setCategory(item);
      setLoading(false);
    }
    fetchCategory(id);
  }, [id]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCategory({
      ...category,
      [name]: value
    });
  }

  const goBack = () => {
    history.goBack();
  }

  const save = async () => {
    try {
      const { name, description } = category
      await updateCategory(id, { name, description });
      enqueueSnackbar(`${name} editado`, {
        variant: 'success',
        resumeHideDuration: 3000,
        anchorOrigin:
          { horizontal: 'right', vertical: 'bottom' },
      });
      history.push('/categories');
    } catch (err) {
      enqueueSnackbar(JSON.stringify(err), {
        variant: 'error',
        resumeHideDuration: 6000,
        anchorOrigin:
          { horizontal: 'right', vertical: 'bottom' },
      });
    }
  }

  return loading ? (
    <BackdropComponent />
  ) : (
    <ViewerComponent>
      <Grid container justifyContent="center" spacing={2}>
        <Grid item>
          <Typography variant="h3" alignt="center">
            Editar categoria
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <TextField
            id="name"
            name="name"
            fullWidth
            label="Nombre de la categoria"
            variant="outlined"
            required
            onChange={handleChange}
            defaultValue={category.name}
          />
        </Grid>
        <Grid item xs={10}>
          <TextField
            id="description"
            name="description"
            fullWidth
            label="Breve descripción de la categoria"
            variant="outlined"
            multiline
            minRows="3"
            onChange={handleChange}
            defaultValue={category.description}
          />
        </Grid>
        <Grid item xs={10}>
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                color="default"
                startIcon={<ArrowBackIcon />}
                onClick={goBack}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={save}
                disabled={!category.name}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ViewerComponent>
  )
}